import { AxiosError } from 'axios';
import { SelectOptionItem } from 'web-library';
import axiosClient from '../axiosClient';
import { useCustomQuery } from '../utils/useCustomQuery';
import { GET_AUDIT_SETTINGS_REPORT_TYPES_URL } from '../../constants/apiUrls';
import { GET_AUDIT_SETTINGS_REPORT_QUERY_KEY } from '../../constants/queryKeys';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Query
// ===========================================================================

interface Input {
  onSuccess: (data: SelectOptionItem[]) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const useGetAuditSettingsReportTypes = ({ onSuccess, onError }: Input) => {
  const getAuditSettingsReportTypes = async () => {
    const res = await axiosClient.get<SelectOptionItem[]>(GET_AUDIT_SETTINGS_REPORT_TYPES_URL);
    return res.data;
  };

  return useCustomQuery(GET_AUDIT_SETTINGS_REPORT_QUERY_KEY, getAuditSettingsReportTypes, {
    onSuccess,
    onError,
  });
};
